// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"MgYIPLCKZ4FTn-JkxBzFI","sidebarLabel":"_1pFhVfD3MeieWTuAlQeQCP","treeContainer":"aLz5QsFx5WTQM9TqGyd2G"};


//////////////////
// WEBPACK FOOTER
// ./src/Root/pages/Notifications/Sidebar/NotificationSidebar.pcss
// module id = 1418
// module chunks = 0